import ThumbDownOutlined from "@mui/icons-material/ThumbDownOutlined";
import ThumbUpOutlined from "@mui/icons-material/ThumbUpOutlined";
import WarningAmberOutlined from "@mui/icons-material/WarningAmberOutlined";
import { Chip } from "@mui/material";



const NiceOpportunityStage = (props) => {
  let stage = props.children;


  if (stage === "To Be Validated"){
    return (<Chip icon={<WarningAmberOutlined />} label="To Be Validated" color={"info"} size="small"/>)
  }

  if (stage === "Rejected"){
    return (<Chip icon={<ThumbDownOutlined />} label="Rejected" color={"error"} size="small"/>)
  }

  if (stage === "To Be Prevented"){
    return (<Chip icon={<ThumbUpOutlined />} label="To Be Prevented" color={"success"} size="small"/>)
  }

};

export default NiceOpportunityStage;
